module.exports = __webpack_public_path__ + "img/wu_b.af6c8fde.png";